import CheckIcon from "../images/CheckIcon.mjs";

/**
 * App mark for a completed task/control
 * @see {GlyphIcon}
 * @see {CheckIcon}
 */
const AppOkIcon = class extends CheckIcon {};

export default AppOkIcon;